import fetch from "auth/FetchInterceptor";

const ResultService = {};

ResultService.fetch = function (params) {
  return fetch({
    url:
      "/results?start_date=" +
      params.startDate +
      "&end_date=" +
      params.endDate +
      "&agency=" +
      params.agency,
    method: "get",
  });
};

// ResultService.fetch = function (params) {
//   return fetch({
//     url: "/results",
//     method: "get",
//   });
// };

ResultService.upload = function (formData) {
  return fetch({
    url: "/results",
    "Content-Type": "multipart/form-data",
    method: "post",
    data: formData,
  });
};

ResultService.update = function (formData) {
  return fetch({
    url: "/results/fake",
    method: "post", // don't change this method. it's tricky . we used post instead of put b/c laravel don't know the form data
    data: formData,
    "Content-Type": "multipart/form-data",
  });
};

export default ResultService;
